var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-checkbox',{staticClass:"form-checkbox",attrs:{"label":_vm.label,"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }